export function getPriceForCurrentDate(
  calendarPricing,
  travelDate,
  returnDate = ''
) {
  const defaultPrice = ''

  if (calendarPricing && Array.isArray(calendarPricing) && travelDate) {
    for (let index = 0; index < calendarPricing.length; index++) {
      const isReturnDateSameIfPresent =
        returnDate === '' || returnDate === calendarPricing[index].returnDate
      if (
        calendarPricing[index].departDate === travelDate &&
        isReturnDateSameIfPresent
      ) {
        return Math.ceil(calendarPricing[index].fare)
      }
    }
  }
  return defaultPrice
}
